module.exports = __webpack_public_path__ + "static/media/ipad3.76f9ab36.png";